import { combineReducers } from "redux";

import listing from "./listing";
import view from "./view";

export default combineReducers({
    listing,
    view
});
